import React, { useState } from 'react';

import './ScreenRecoding.css';

const ScreenRecording = ({
	// screen,
	// audio,
	// video,
	downloadRecordingPath,
	downloadRecordingType,
	emailToSupport,
	setIsPopupOpen,
	isPopupOpen,
	startRecord,
	stopRecord,
	mediaBlobUrl,
	status,
}) => {
	const [recordingNumber, setRecordingNumber] = useState(0);

	const startRecording = () => {
		return startRecord();
	};
	const stopRecording = () => {
		const currentTimeSatmp = new Date().getTime();
		setRecordingNumber(currentTimeSatmp);
		return stopRecord();
	};
	const viewRecording = () => {
		window.open(mediaBlobUrl, '_blank').focus();
	};
	const downloadRecording = () => {
		const pathName = `${downloadRecordingPath}_${recordingNumber}.${downloadRecordingType}`;
		try {
			if (window.navigator && window.navigator.msSaveOrOpenBlob) {
				// for IE
				window.navigator.msSaveOrOpenBlob(mediaBlobUrl, pathName);
			} else {
				// for Chrome
				const link = document.createElement('a');
				link.href = mediaBlobUrl;
				link.download = pathName;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
		} catch (err) {
			console.error(err);
		}
	};
	const mailRecording = () => {
		try {
			window.location.href = `mailTo:${emailToSupport}?subject=Screen recording for an Issue number ${recordingNumber}&body=Hello%20Team,%0D%0A%0D%0A${mediaBlobUrl}`;
		} catch (err) {
			console.error(err);
		}
	};

	console.log('ssss', status);

	return (
		<div className="Scren-Record-Wrapper" style={{ padding: '5px 20px' }}>
			{((status === 'idle' || status === 'acquiring_media' || status === 'stopped') && isPopupOpen === false) && (
				<div className="recording_container">
					<button
						className="start_recording"
						onClick={() => {
							startRecording();
						}}
					>
						<svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M2.16683 11.3333C1.80016 11.3333 1.48627 11.2028 1.22516 10.9417C0.964052 10.6806 0.833496 10.3667 0.833496 10V2C0.833496 1.63333 0.964052 1.31944 1.22516 1.05833C1.48627 0.797223 1.80016 0.666667 2.16683 0.666667H10.1668C10.5335 0.666667 10.8474 0.797223 11.1085 1.05833C11.3696 1.31944 11.5002 1.63333 11.5002 2V5L14.1668 2.33333V9.66667L11.5002 7V10C11.5002 10.3667 11.3696 10.6806 11.1085 10.9417C10.8474 11.2028 10.5335 11.3333 10.1668 11.3333H2.16683Z" fill="white"/>
							</svg>
							<span style={{marginLeft: '10px'}}>Start Recording</span>
					</button>
				</div>
			)}
			{status === 'recording' && (
				<div className="recording_container recording_container_stop">
					<button
						className="stop_recording"
						onClick={() => {
							stopRecording();
							setIsPopupOpen(!isPopupOpen);
						}}
					>
					<svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M4.83301 9.66667H10.1663V4.33333H4.83301V9.66667ZM7.49967 13.6667C6.57745 13.6667 5.71079 13.4917 4.89967 13.1417C4.08856 12.7917 3.38301 12.3167 2.78301 11.7167C2.18301 11.1167 1.70801 10.4111 1.35801 9.6C1.00801 8.78889 0.833008 7.92222 0.833008 7C0.833008 6.07778 1.00801 5.21111 1.35801 4.4C1.70801 3.58889 2.18301 2.88333 2.78301 2.28333C3.38301 1.68333 4.08856 1.20833 4.89967 0.858333C5.71079 0.508333 6.57745 0.333333 7.49967 0.333333C8.4219 0.333333 9.28856 0.508333 10.0997 0.858333C10.9108 1.20833 11.6163 1.68333 12.2163 2.28333C12.8163 2.88333 13.2913 3.58889 13.6413 4.4C13.9913 5.21111 14.1663 6.07778 14.1663 7C14.1663 7.92222 13.9913 8.78889 13.6413 9.6C13.2913 10.4111 12.8163 11.1167 12.2163 11.7167C11.6163 12.3167 10.9108 12.7917 10.0997 13.1417C9.28856 13.4917 8.4219 13.6667 7.49967 13.6667Z" fill="#FF3131"/>
						</svg>

						<span style={{marginLeft: '10px'}}>Stop Recording</span>
					</button>
				</div>
			)}
		</div>
	);
};
export default ScreenRecording;
